module.exports = __webpack_public_path__ + "static/media/Hacker __ Sponsor Networking.57bd52ae.png";